<!-- This is a speech bubble like tooltip with configurable "tip" placement -->
<template>
  <div
    class="triangle-section d-flex justify-content-start"
    :class="`justify-content-${position}`">
    <div class="triangle-wrapper d-flex justify-content-center">
      <!-- We use an SVG instead of CSS to have a continuous border on the entire tooltip -->
      <svg
        width="42"
        height="22"
        viewBox="0 0 42 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 1L1 21H41L21 1Z"
          fill="white"/>
        <path
          d="M1 20L21 1L41 20"
          stroke="#BABABF"
          stroke-width="0.5"/>
      </svg>
    </div>
  </div>

  <div class="callout-content">
    <slot/>
  </div>
</template>

<script setup>
defineProps({
  position: {
    type: String,
    default: 'center'
  }
})
</script>

<style scoped lang="scss">
.callout-content {
  background-color: white;
  border-radius: 4px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  padding: 16px;
  border: solid .5px $ash;
  animation: fadeIn 0.75s forwards;
}
.triangle-section {
  position: relative;
  margin: 0 auto;
  // hides the rectangle's border that overlaps with the triangle
  bottom: -2px;
}
.triangle-wrapper {
// with deep styling, we can adjust the wrapper's width to define placement of the triangle tip
  width: 33%;
}
</style>
